export default __webpack_public_path__ + "static/media/help-small.c34eb10f.svg";